export enum NotificationAssigneeType {
    Underwriter = 'Underwriter',
    Agent = 'Agent',
}
